import { render, staticRenderFns } from "./PreviewTable.vue?vue&type=template&id=e3459170&scoped=true"
import script from "./PreviewTable.vue?vue&type=script&setup=true&lang=js"
export * from "./PreviewTable.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PreviewTable.vue?vue&type=style&index=0&id=e3459170&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3459170",
  null
  
)

export default component.exports